import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";

import { getAlphaVersionImage } from "../api/alphaEditor.api";

type DownloadTarget = { fileName: string; versionId: string };

// The CDN image is cross-origin, where <a download> is ignored, so download the proxied blob instead.
export function useDownloadAlphaVersion(
  requestId: number,
): UseMutationResult<void, Error, DownloadTarget> {
  return useMutation({
    mutationFn: async ({ fileName, versionId }) => {
      const image = await getAlphaVersionImage(requestId, versionId);
      const url = URL.createObjectURL(image);
      const link = document.createElement("a");

      link.href = url;
      link.download = `${fileName}.${image.type.split("/")[1] ?? "png"}`;
      link.click();
      URL.revokeObjectURL(url);
    },
    onError: () => {
      toast.add({
        description: "Something went wrong",
        title: "Could not download the image",
        type: "error",
      });
    },
  });
}
